module.exports = __webpack_public_path__ + "img/medalha-empreendedorismo-no-ambiente-escolar.3dfd5486.jpg";